import api from "@/lib/api/http";
import { asJson } from "@/lib/api/headers";

export const listNotifications = async ({ limit = 50, before } = {}) => {
  const params = new URLSearchParams();
  params.set("limit", String(limit));
  if (before) params.set("before", before);

  const response = await api.get(`/notifications?${params.toString()}`);
  return response.data;
};

export const markNotificationRead = async (id) => {
  const response = await api.post(`/notifications/${id}/read`, null, asJson());
  return response.data;
};

export const markAllNotificationsRead = async () => {
  const response = await api.post("/notifications/read-all", null, asJson());
  return response.data;
};

export const dismissNotification = async (id) => {
  const response = await api.post(`/notifications/${id}/dismiss`, null, asJson());
  return response.data;
};
